"use client"
import { Box, Typography, Container, useMediaQuery, useTheme, Button } from "@mui/material"
import { styled } from "@mui/material/styles"
import oppback from "../../../assets/images/oppback.png"
import { Link } from "react-router-dom"


// Styled components
const HeroContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundImage: `url(${oppback})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "500px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(4, 2),
  textAlign: "center",
  color: "#fff",
}))

// Styled buttons
const ActionButton = styled(Button)(({ theme, variant }) => ({
  borderRadius: "8px",
  padding: theme.spacing(1.5, 4),
  fontSize: "1rem",
  fontWeight: 600,
  textTransform: "none",
  minWidth: "180px",
  height: "56px",
  ...(variant === "primary" && {
    backgroundColor: "#D15424",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#ffffff",
      color: "#D15424",
    },
  }),
  ...(variant === "secondary" && {
    backgroundColor: "#fff",
    color: "#333",
    border: "2px solid #E25822",
    "&:hover": {
      backgroundColor: "#E25822",
      color : "#fff",
    },
  }),
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginBottom: theme.spacing(1),
  },
}))

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(3),
  marginTop: theme.spacing(4),
  justifyContent: "center", // Center the buttons horizontally
  width: "100%", // Ensure the container takes full width
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "center", // Center buttons when stacked
    maxWidth: "300px",
  },
}))

const JobSearchHero = () => {
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <HeroContainer>
      <Container maxWidth="lg" sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "70vh" }}>
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontFamily: "Monserrat, sans-serif",
            fontWeight: 700,
            fontSize: { xs: "2.5rem", sm: "3.5rem", md: "4rem" },
            mb: 2,
            textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            mt: mobile ? 4 : 0,
          }}
        >
          Hire Smarter. Grow Faster.
        </Typography>

        <Typography
          variant="h6"
          component="p"
          sx={{
            fontFamily: "Monserrat, sans-serif",
            fontWeight: 400,
            fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
            mb: 4,
            maxWidth: "800px",
            mx: "auto",
            opacity: 0.9,
          }}
        >
          Connecting Top Talent with Businesses
        </Typography>

        <ButtonContainer>
          <Link to={"/talents/hire"}>
          <ActionButton variant="primary">Hire Talent</ActionButton>
          </Link>
          <Link to={"/talents/register"}>
            <ActionButton variant="secondary">Find Opportunity</ActionButton>
          </Link>
        </ButtonContainer>
      </Container>
    </HeroContainer>
  )
}

export default JobSearchHero

